// extracted by mini-css-extract-plugin
module.exports = {"homeImg":"Home_homeImg__1igYK","homeImgCol":"Home_homeImgCol__3dNNW","topContainer":"Home_topContainer__1ocY4"};